import { useEffect, useState } from 'react';

const useIsLoadedConent = (success: boolean): boolean => {
  const [isSuccess, setIsSuccess] = useState(success);

  useEffect(() => {
    if (success) {
      setIsSuccess(true);
    }
  }, [success]);

  return isSuccess;
};

export default useIsLoadedConent;
